import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

/**
 * App shell shared by every route. Keeps scroll position sensible on
 * client-side navigation and honours in-page hash anchors (e.g. "/#pricing").
 * All of this is progressive enhancement — the pre-rendered HTML is fully
 * usable before this ever runs.
 */
export default function RootLayout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only treat the hash as an in-page anchor when it is a simple "#id" (letters,
    // digits, - and _). Libraries that use hash-based routing (e.g. Clerk's sign-in
    // renders "#/?redirect_url=…") put non-selector text in the hash, and passing that
    // to querySelector throws a SyntaxError that would crash the whole shell.
    if (hash && /^#[\w-]+$/.test(hash)) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);

  return <Outlet />;
}
